import React from 'react';
import config from '../configuration/configuration';
const mppSpinner = (props) => {

    return (
        <React.Fragment>
            <div id="mpp-spinner" className="spinner-container" style={{ display: props.isDisplayed }}>
                <img id="dBuyLoadingImage" alt="loading" className="spinnerImage" src={config[window._syfMpp_.SYF_MPP_ENV].dbuyQa + config[window._syfMpp_.SYF_MPP_ENV].syfLoadingImageURL} />
            </div>
        </React.Fragment>
    );
}
export default mppSpinner;